const STORAGE_KEY = 'cadira_auth_session_notice';

const hasSessionStorage = () =>
	typeof window !== 'undefined' && !!window.sessionStorage;

export const queueAuthSessionNotice = (notice) => {
	if (!hasSessionStorage() || !notice?.text) return;

	try {
		window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notice));
	} catch (error) {
		// Best effort only.
	}
};

export const consumeAuthSessionNotice = () => {
	if (!hasSessionStorage()) return null;

	try {
		const raw = window.sessionStorage.getItem(STORAGE_KEY);
		window.sessionStorage.removeItem(STORAGE_KEY);

		if (!raw) return null;

		const parsed = JSON.parse(raw);
		if (!parsed?.text) return null;

		return {
			type: parsed.type || 'warning',
			text: parsed.text,
		};
	} catch (error) {
		window.sessionStorage.removeItem(STORAGE_KEY);
		return null;
	}
};
